import { api } from '../lib/http';
import type {
  ContentTier,
  FavoriteSkin,
  Storefront,
  ValorantRegion,
  WeaponSkin,
} from '@vst/shared';

export interface MeResponse {
  telegramId: number;
  firstName: string;
  username?: string;
  hasRiotLink: boolean;
  riotRegion: ValorantRegion | null;
  riotPuuid: string | null;
  languageCode: string;
  notificationsEnabled: boolean;
}

export interface LoginSuccess {
  success: true;
  user: MeResponse;
}

export interface LoginRequireMfa {
  success: false;
  requireMultifactor: true;
  multifactorEmail: string;
  sessionId: string;
}

export type LoginResponse = LoginSuccess | LoginRequireMfa;

export function getMe() {
  return api.get<MeResponse>('/auth/me');
}

export function requestCaptcha() {
  return api.post<{
    sessionId: string;
    captchaSiteKey: string;
    captchaData: string;
  }>('/auth/captcha');
}

export function login(params: {
  sessionId: string;
  username: string;
  password: string;
  captchaToken: string;
  region: ValorantRegion;
}) {
  return api.post<LoginResponse>('/auth/login', params);
}

export function submitMfa(params: { sessionId: string; code: string }) {
  return api.post<{ success: true; user: MeResponse }>('/auth/mfa', params);
}

export function logout() {
  return api.post<{ success: true }>('/auth/logout');
}

export function getStore() {
  return api.get<Storefront>('/store');
}

export function getAllSkins() {
  return api.get<{ skins: WeaponSkin[]; tiers: ContentTier[] }>('/skins');
}

export function getFavorites() {
  return api.get<FavoriteSkin[]>('/favorites');
}

export function addFavoriteApi(skinUuid: string) {
  return api.post<{ success: true }>('/favorites', { skinUuid });
}

export function removeFavoriteApi(skinUuid: string) {
  return api.delete<{ success: true }>(`/favorites/${skinUuid}`);
}

export function setNotifications(enabled: boolean) {
  return api.patch<{ success: true; enabled: boolean }>('/settings/notifications', { enabled });
}
